import { useMutation, useQueryClient } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';
import { FindRunningChargePointsQueryKey } from '@services/queries/use-find-running-charge-points.query.ts';

export const DisconnectClientMutationKey = 'disconnect-client';

interface DisconnectClientData {
  cpid: string;
}

export const useDisconnectClient = () => {
  const queryClient = useQueryClient();

  return useMutation(
    DisconnectClientMutationKey,
    async ({ cpid }: DisconnectClientData) => {
      await apiCpService.disconnectClientCpClientCpidDelete(cpid);
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(FindRunningChargePointsQueryKey);
      },
    },
  );
};
